export default __webpack_public_path__ + "static/media/MainDC.0a5a0266.jpg";